const math = require('mathjs');

class Transform {
  #matrix4x4;

  static isTransform(value) {
    return value instanceof Transform;
  }

  static rotate(thetaX, thetaY, thetaZ) {
    const rotationMatricies = [
      math.matrix([
        [1, 0, 0, 0],
        [0, math.cos(thetaX), -math.sin(thetaX), 0],
        [0, math.sin(thetaX), math.cos(thetaX), 0],
        [0, 0, 0, 1],
      ]), math.matrix([
        [math.cos(thetaY), 0, math.sin(thetaY), 0],
        [0, 1, 0, 0],
        [-math.sin(thetaY), 0, math.cos(thetaY), 0],
        [0, 0, 0, 1],
      ]), math.matrix([
        [math.cos(thetaZ), -math.sin(thetaZ), 0, 0],
        [math.sin(thetaZ), math.cos(thetaZ), 0, 0],
        [0, 0, 1, 0],
        [0, 0, 0, 1],
      ]),
    ];

    // Multiply the matricies together:
    return new Transform(rotationMatricies.reduce((acc, matrix) => math.multiply(acc, matrix)));
  }

  static translate(x, y, z) {
    return new Transform(math.matrix([
      [1, 0, 0, x],
      [0, 1, 0, y],
      [0, 0, 1, z],
      [0, 0, 0, 1],
    ]));
  }

  static scale(factorXOrCommonFactor, factorY, factorZ) {
    const factorX = factorXOrCommonFactor;
    factorY = Number.isFinite(factorY) ? factorY : factorXOrCommonFactor;
    factorZ = Number.isFinite(factorZ) ? factorZ : factorXOrCommonFactor;

    return new Transform(math.matrix([
      [factorX, 0, 0, 0],
      [0, factorY, 0, 0],
      [0, 0, factorZ, 0],
      [0, 0, 0, 1],
    ]));
  }

  constructor(matrix4x4) {
    this.#matrix4x4 = matrix4x4;
  }

  then(other) {
    return new Transform(math.multiply(other.asMatrix4x4(), this.#matrix4x4));
  }

  get inverse() {
    return new Transform(math.inv(this.#matrix4x4));
  }

  asMatrix4x4() {
    return this.#matrix4x4;
  }
}

module.exports = Transform;
